import { useEffect, useState } from 'react';

const useDebounce = <TState,>(value: TState, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState<TState>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
